<template>
    <b-modal v-model="modalAberto" scrollable centered title="Solicitar alterações" header-bg-variant="secondary"
    header-text-variant="light" size="lg" @hide="closeModal">
        <b-overlay :show="this.carregandoModalAlt">
            <b-card header="Selecione quais dados serão solicitados:" header-class="text-center font-weight-bold">
                <b-form>
                    <b-container fluid>
                        <b-row>
                            <b-col cols="12" lg="6" v-for="solicitacao in solicitacoes" :key="solicitacao.key">
                                <b-form-group>
                                    <b-form-checkbox v-model="solicitacao.selecionado">{{
                                        solicitacao.label
                                    }}</b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-form>
            </b-card>
        </b-overlay>
      <template #modal-footer>
        <b-button size="sm" variant="success"
          @click="solicitarAlteracoes(String(idUsuario))">Enviar</b-button>
      </template>
    </b-modal>
</template>

<script lang="ts">

import { Solicitacao } from "@/types/administracao/aprovar-novos-usuarios/solicitacao";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Prop } from "vue-property-decorator";
import usuarioService from "@/services/administracao/usuarioService";

@Component({
    components: {},
})
export default class ModalAlteracoes extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) idUsuario!: number;

    carregandoModalAlt = false
    modalAberto = true

    solicitacoes: Solicitacao[] = [
    {
      key: "nome",
      label: "Nome",
      selecionado: false,
      texto: "nome",
    },
    {
      key: "telefone",
      label: "Telefone",
      selecionado: false,
      texto: "telefone",
    },
    {
      key: "numero",
      label: "Número (do endereço)",
      selecionado: false,
      texto: "numero",
    },
    {
      key: "bairro",
      label: "Bairro",
      selecionado: false,
      texto: "bairro",
    },
    {
      key: "municipio",
      label: "Município",
      selecionado: false,
      texto: "municipio",
    },
    {
      key: "comprovanteResidencia",
      label: "Comprovante de residência",
      selecionado: false,
      texto: "comprovante_residencia",
    },
    {
      key: "codigoOAB",
      label: "Código OAB",
      selecionado: false,
      texto: "oab",
    },
    {
      key: "logradouro",
      label: "Logradouro",
      selecionado: false,
      texto: "logradouro",
    },
    {
      key: "complemento",
      label: "Complemento (do endereço)",
      selecionado: false,
      texto: "complemento",
    },
    {
      key: "cep",
      label: "CEP",
      selecionado: false,
      texto: "cep",
    },
    {
      key: "documentoCPF",
      label: "Documento com CPF e foto",
      selecionado: false,
      texto: "doc_cpf",
    },
  ];

  async solicitarAlteracoes(id: string) {
    const solicitacoesSelecionadas = this.solicitacoes
      .filter((solicitacao) => solicitacao.selecionado)
      .map((solicitacao) => solicitacao.texto);
    try {
      this.carregandoModalAlt = true;
      const response = await usuarioService.solicitarMudancas(
        id,
        solicitacoesSelecionadas
      );
      this.$toast.success("Alterações solicitadas com sucesso!");
      this.closeModal()
      this.$emit("reload")
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.carregandoModalAlt = false;
      this.resetarSolicitacoes();
    }
  }

  resetarSolicitacoes() {
    this.solicitacoes.forEach((solicitacao) => {
      solicitacao.selecionado = false;
    });
  }

  closeModal() {
    this.resetarSolicitacoes();
    this.$emit("close");
  }

}
</script>